import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@app/App";
import { GameApp } from "@game/GameApp";

const container = document.getElementById("root");
if (!container) throw new Error("root element not found");

// Two entry modes:
//   - default ("game") → real game client
//   - "?demo=1" or VITE_BOOT_MODE=demo → engine demo switcher (8 demos)
const url = new URL(window.location.href);
const mode = url.searchParams.get("demo") === "1"
  ? "demo"
  : (import.meta as { env?: Record<string, string> }).env?.VITE_BOOT_MODE === "demo"
    ? "demo"
    : "game";

createRoot(container).render(
  <StrictMode>
    {mode === "demo" ? <App /> : <GameApp />}
  </StrictMode>,
);
